export * from './sync-all.action';
